/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'back': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M285.44 399.36L534.4 150.4a32 32 0 00-45.44-45.44l-248.32 249.6a32 32 0 0044.8 44.8zM864 480H128a32 32 0 00-22.4 55.04l384 384a32 32 0 0045.44-45.44L205.44 544H864a32 32 0 000-64z"/>'
  }
})
